export enum EDateFormats {
  date = 'MM/dd/yyyy',
  'yyyy/MM/dd' = 'yyyy/MM/dd',
  'dd/MM/yyyy HH:mm:ss' = 'dd/MM/yyyy HH:mm:ss',
  'yyyyMMddhhmm' = 'yyyyMMddhhmm',
}
